<template>
  <div>
    <div class="ts-flex justify-content-between">
      <h1 class="page-header">
        {{
          $t('school.academic.operation.profile_mgt.parentProfile.pageTitle')
        }}
      </h1>
      <ts-breadcrumb :items="[
            { text: $t('toHomePage'), href: '/' },
            {
              text: $t(
                'school.academic.operation.profile_mgt.parentProfile.pageTitle'
              ),
              active: true,
            },
          ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex justify-content-between">
          <div class="justify-content-start">
            <ts-button color="info" outline @click="$router.push({ name: 'parent-profile-create' })">
              {{ $t('add_new') }}
            </ts-button>
            <ts-button class="ml-2" @click="showFormGenerate">{{
              $t(
                'school.academic.operation.profile_mgt.parentProfile.generatePickupCard'
              )
            }}</ts-button>
          </div>
          <div class="ts-flex-grow"></div>
          <div class="justify-content-end mr-2">
            <ts-input v-model="search" :placeholder="$t('search')" style="width: 300px" />
          </div>
          <ts-button outline v-tooltip="$t('filter')" @click.prevent="visible = true">
            <i class="fa fa-filter"></i>
          </ts-button>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="kh-font">{{ record.parent_id }}</td>
            <td class="with-img">
              <img class="height-30 ts-rounded" v-lazy="{
                src: photoFather(record.father_photo),
                error: onFatherError,
                loading: require('@/assets/Rolling-1s-200px_2.svg'),
              }" />
            </td>
            <td class="kh-font">{{ record.father_name_kh }}</td>
            <td class="kh-font">{{ record.father_name_en }}</td>
            <td class="kh-font">
              {{ record.father_phone1 }}
              {{ record.father_phone2 ? '/' + record.father_phone2 : '' }}
            </td>
            <td class="with-img">
              <img class="height-30 ts-rounded" v-lazy="{
                src: photoMother(record.mother_photo),
                error: onMotherError,
                loading: require('@/assets/Rolling-1s-200px_2.svg'),
              }" />
            </td>
            <td class="kh-font">{{ record.mother_name_kh }}</td>
            <td>{{ record.mother_name_en }}</td>
            <td class="kh-font">
              {{ record.mother_phone1 }}
              {{ record.mother_phone2 ? '/' + record.mother_phone2 : '' }}
            </td>
            <td class="kh-font text-center">
              <a href="#" title="Edit" class="mr-2 text-primary" @click.prevent="edit(record)">
                <i class="fas fa-edit"></i>
              </a>
              <a href="#" title="Delete" class="text-danger" @click.prevent="destroy(record)"
                :disabled="record._deleting">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
    <a-drawer :title="$t('invoice.filter')" placement="right" :closable="false" :visible="visible"
      @close="() => (visible = false)" :zIndex="1020" width="300px">
      <div style="font-size: 12px">
        <div class="row">
          <legend class="text-black ts-text-sm">
            {{ $t('parentprofile.fatherPhotoUpload') }}
          </legend>
          <div class="form-group">
            <div class="radio radio-css radio-inline is-valid">
              <input v-model="father_photo_exists" type="radio" id="father_photo" :value="'yes'" />
              <label for="father_photo">
                {{ $t('uploaded') }}
              </label>
            </div>
            <div class="radio radio-css radio-inline is-invalid">
              <input v-model="father_photo_exists" type="radio" id="no_father_upload" :value="'no'" />
              <label for="no_father_upload">
                {{ $t('parentprofile.notYetUpload') }}
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <legend class="text-black ts-text-sm">
            {{ $t('parentprofile.motherPhotoUpload') }}
          </legend>
          <div class="form-group">
            <div class="radio radio-css radio-inline is-valid">
              <input v-model="mother_photo_exists" type="radio" id="mother_photo" :value="'yes'" />
              <label for="mother_photo">
                {{ $t('uploaded') }}
              </label>
            </div>
            <div class="radio radio-css radio-inline is-invalid">
              <input v-model="mother_photo_exists" type="radio" id="no_mother_upload" :value="'no'" />
              <label for="no_mother_upload">
                {{ $t('parentprofile.notYetUpload') }}
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <legend class="text-black ts-text-sm">
            {{ $t('parentprofile.pickupCard') }}
          </legend>
          <div class="form-group">
            <div class="radio radio-css radio-inline is-valid">
              <input v-model="pickup_card" type="radio" id="created" :value="'yes'" />
              <label for="created">
                {{ $t('parentprofile.created') }}
              </label>
            </div>
            <div class="radio radio-css radio-inline is-invalid">
              <input v-model="pickup_card" type="radio" id="no_create" :value="'no'" />
              <label for="no_create">
                {{ $t('parentprofile.notYetCreate') }}
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <legend class="text-black ts-text-sm">
            {{ $t('parentprofile.cardActivation') }}
          </legend>
          <div class="form-group">
            <div class="radio radio-css radio-inline is-valid">
              <input v-model="id_card_activated" type="radio" id="activated" :value="'yes'" />
              <label for="activated">
                {{ $t('parentprofile.activated') }}
              </label>
            </div>
            <div class="radio radio-css radio-inline is-invalid">
              <input v-model="id_card_activated" type="radio" id="no_activated" :value="'no'" />
              <label for="no_activated">
                {{ $t('parentprofile.notYetActivate') }}
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <legend class="text-black ts-text-sm">
            {{ $t('parentprofile.usedApp') }}
          </legend>
          <div class="form-group">
            <div class="radio radio-css radio-inline is-valid">
              <input v-model="used_app" type="radio" id="used" :value="'yes'" />
              <label for="used">
                {{ $t('parentprofile.used') }}
              </label>
            </div>
            <div class="radio radio-css radio-inline is-invalid">
              <input v-model="used_app" type="radio" id="no_use" :value="'no'" />
              <label for="no_use">
                {{ $t('parentprofile.notYetUse') }}
              </label>
            </div>
          </div>
        </div>
        <div class="mb-3 row">
          <label>{{ $t('parentprofile.branch') }}</label>
          <a-select v-model="branchId" :options="branchs" :placeholder="$t('all')" mode="multiple" :show-search="true"
            :filter-option="(input, option) =>
              option.componentOptions.children[0].text
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
              " class="ts-w-full"></a-select>
        </div>
        <div class="row">
          <ts-button class="btn-block" @click.prevent="clearFilter">
            <i class="far fa-times-circle"></i>
            {{ $t('parentprofile.clearFilter') }}
          </ts-button>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import GenerateForm from './component/generate-card'
export default {
  name: 'parentProfile',
  data() {
    return {
      loading: false,
      visible: false,
      branchs: []
    }
  },
  computed: {
    ...mapState('parentProfile', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.parentProfile.search
      },
      set(newValue) {
        this.$store.commit('parentProfile/SET_SEARCH', newValue)
        this.$store.commit('parentProfile/RESET_CURRENT_PAGE')
      },
    },
    father_photo_exists: {
      get() {
        return this.$store.state.parentProfile.father_photo_exists
      },
      set(newValue) {
        this.$store.commit('parentProfile/SET_FATHER_PHOTO_EXISTS', newValue)
      },
    },
    mother_photo_exists: {
      get() {
        return this.$store.state.parentProfile.mother_photo_exists
      },
      set(newValue) {
        this.$store.commit('parentProfile/SET_MOTHER_PHOTO_EXISTS', newValue)
      },
    },
    pickup_card: {
      get() {
        return this.$store.state.parentProfile.pickup_card
      },
      set(newValue) {
        this.$store.commit('parentProfile/SET_PICKUP_CARD', newValue)
      },
    },
    id_card_activated: {
      get() {
        return this.$store.state.parentProfile.id_card_activated
      },
      set(newValue) {
        this.$store.commit('parentProfile/SET_ID_CARD_ACTIVATED', newValue)
      },
    },
    used_app: {
      get() {
        return this.$store.state.parentProfile.used_app
      },
      set(newValue) {
        this.$store.commit('parentProfile/SET_USED_APP', newValue)
      },
    },
    branchId: {
      get() {
        return this.$store.state.parentProfile.branch_id
      },
      set(newValue) {
        this.$store.commit('parentProfile/SET_BRANCH_ID', newValue)
      }
    },
    columns() {
      return [
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.parentProfile.parentId'
          ),
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.parentProfile.photo'
          ),
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.parentProfile.fatherNameKH'
          ),
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.parentProfile.fatherNameEN'
          ),
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.parentProfile.phoneNumber'
          ),
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.parentProfile.photo'
          ),
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.parentProfile.motherNameKH'
          ),
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.parentProfile.motherNameEN'
          ),
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.parentProfile.phoneNumber'
          ),
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:5%',
        },
      ]
    },
  },
  created() {
    this.fetchBranch()
    this.branchId = this.$store.state.authUser
      ? [this.$store.state.authUser.default_branch_id]
      : []
    this.fetchData()
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('parentProfile/fetch', attributes)
        .then((response) => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('parentProfile/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'parent-profile-edit',
        params: { id: record.student_parent_id },
      })
    },
    async destroy(record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('parentProfile/destroy', record.student_parent_id)
          .then((response) => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch((error) => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    photoFather(photo) {
      if (photo) {
        return photo
      }

      return require('../../assets/staff-default-man.png')
    },
    photoMother(photo) {
      if (photo) {
        return photo
      }

      return require('../../assets/staff-default-women.png')
    },
    onFatherError() {
      event.target.src = require('../../assets/staff-default-man.png')
    },
    onMotherError() {
      event.target.src = require('../../assets/staff-default-women.png')
    },
    showFormGenerate() {
      this.$modal.show(
        GenerateForm,
        {},
        {
          height: 'auto',
          width: '20%',
          scrollable: true,
          clickToClose: false,
        }
      )
    },
    clearFilter() {
      this.father_photo_exists = null
      this.mother_photo_exists = null
      this.pickup_card = null
      this.id_card_activated = null
      this.used_app = null
    },
    fetchBranch() {
      this.loading = true
      this.$store
        .dispatch('parentProfile/getBranch')
        .then((response) => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    father_photo_exists: debounce(function (val) {
      this.fetchData({ val })
    }, 500),
    mother_photo_exists: debounce(function (val) {
      this.fetchData({ val })
    }, 500),
    pickup_card: debounce(function (val) {
      this.fetchData({ val })
    }, 500),
    id_card_activated: debounce(function (val) {
      this.fetchData({ val })
    }, 500),
    used_app: debounce(function (val) {
      this.fetchData({ val })
    }, 500),
    branchId: debounce(function (val) {
      this.fetchData({ val })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'parent-profile-create') {
      this.$store.commit('parentProfile/RESET_STATE')
    }
    next()
  },
}
</script>
